import LocalStorage from '@/helpers/localstorage.js';
import { SET_USER, SET_LOGGEDIN_STATUS } from '../mutation_types';
import { USER_LOGIN, USER_LOGOUT, SET_FACTOR2 } from '../action_types';

const state = {
    loggedIn: false,
    userName: '',
    roles: [],
    sid: '',
    factor2: {
        token: null,
        uuid: null
    }
};

const getters = {
    getLoggedin(state) {
        return state.loggedIn;
    },
    // getRoleAdmin(state) {
    //     if (state.roles.indexOf('ROLE_USER_ADMIN' > -1)) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // },
    getRole: (state) => (role) => {
        if (state.roles.indexOf(role) > -1) {
            return true;
        } else {
            return false;
        }
    },
    getRoleAvaliable: (state, getters) => (roleArray) => {
        if (roleArray.some(role => getters.getRole(role))){
            return true;
        } else {
            return false;
        }
    },
    getRoleConflict: (state, getters) => (roles) => {
        let i = 0;
        let roleConflict = false;
        while(i < roles.length && !roleConflict) {
          if (roles.some(role => getters.getRole(role))) {
            i += 1
          } else {
            roleConflict = true;
          }
        }
        return roleConflict;
    }
    // },
    // getRoleUser(state) {
    //     if (state.roles.indexOf('ROLE_USER' > -1)) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }
};


const mutations = {
    [SET_USER] (state, payload) {
        state.userName = payload.userName;
        state.sid = payload.sid;
        state.roles = payload.roles;
    },
    [SET_LOGGEDIN_STATUS] (state, payload) {
        state.loggedIn = payload.loggedInStatus;
    },
    [SET_FACTOR2] (state, payload) {
        let newFactor2 = {};
        newFactor2 = {
            token: payload.token,
            uuid: payload.uuid,
            rememberMe: payload.rememberMe
        }
        state.factor2 = newFactor2
    }
};

const actions = {
    [USER_LOGIN] ({ commit }, payload) {
        commit({
            type: SET_USER,
            userName: payload.userName,
            roles: payload.roles,
            sid: payload.sid
        })
        commit({
            type: SET_LOGGEDIN_STATUS,
            loggedInStatus: true
        });

    },
    async [USER_LOGOUT] ({commit}) {
        commit({
            type: SET_USER,
            userName: '',
            roles: [],
            sid: ''
        })
        commit({
            type: SET_LOGGEDIN_STATUS,
            loggedInStatus: false
        });
        LocalStorage.deleteUserData();
        LocalStorage.deleteJwt();
    },
};


export default {
    state,
    getters,
    mutations,
    actions
}